import React, { useState, useEffect } from "react";
import Carousel from "react-spring-3d-carousel-2";
import { config } from "react-spring";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import "./memoryhighlights.css";

export default function MemoriesHighlight() {
  let slides = [];
  const imgURL = process.env.REACT_APP_MORGANROCKS_CDN_URL;
  const arrowimg = process.env.REACT_APP_CDN_URL;

  const [EventPics, setEventPics] = useState([]);

  const audio = new Audio();
  audio.src = process.env.REACT_APP_CLICK_SOUND;

  const [state, setState] = useState({
    goToSlide: 0,
    offsetRadius: 3,
    showNavigation: false,
    config: config.gentle,
    draggable: true,
  });

  let xDown = null;
  let yDown = null;

  const getTouches = (evt) => {
    return (
      evt.touches || evt.originalEvent.touches // browser API
    ); // jQuery
  };


  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
    audio.play();
  };

  const handleTouchMove = (evt) => {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        setState({ goToSlide: state.goToSlide + 1, offsetRadius: 3 });
      } else {
        /* right swipe */
        setState({ goToSlide: state.goToSlide - 1, offsetRadius: 3 });
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    audio.play();
    /* reset values */
    xDown = null;
    yDown = null;
  };

  useEffect(() => {
    // Get the event pics from a JSON file hosted in the cdn
    async function fetchEventPics() {
      try {
        const memoryPics = await axios.get(process.env.REACT_APP_EVENT_CDN_URL);
        // console.log(memoryPics.data);
        let memoryPicsData = memoryPics.data;
        for (var data of memoryPicsData) {
          slides.push({
            key: data.imgPath,
            content: (
              <img
                src={imgURL + data.imgPath}
                className="eventpics"
                alt="event memories"
              />
            ),
          });
        }
        // console.log("slides: " + JSON.stringify(slides));
        let BannerPicsData = slides.map((slide, index) => {
          return {
            ...slide,
            onClick: () => setState({ goToSlide: index, offsetRadius: 3 }),
          };
        });
        setEventPics(BannerPicsData);
      } catch (err) {
        console.log(err);
      }
    }
    fetchEventPics();
  }, []);

  return (
    <>
      <div>

        <Container>
          <Row className="memories-row">
            <div className="memovideosection memoeventsection">
              <p className="event-heading">
                Event Memories
              </p>
            </div>
            <Col lg={12} xl={12} md={12} sm={12}>
              <div
                className="events"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
              >
                <Carousel
                  slides={EventPics}
                  autoPlay
                  draggable={state.draggable}
                  goToSlide={state.goToSlide}
                  offsetRadius={state.offsetRadius}
                  showNavigation={state.showNavigation}
                  animationConfig={state.config}
                  goToSlideDelay="20000"
                  interval={20}
                />
              </div>
              <div className="arrows">
                <img
                  src={arrowimg + "blue-arrow-left.png"}
                  className="leftarrow"
                  alt="leftnavigation"
                  onClick={() => {
                    setState({
                      goToSlide: state.goToSlide - 1,
                      offsetRadius: 3,
                    });
                    audio.play();
                  }}
                />
                <img
                  src={arrowimg + "blue-arrow-right.png"}
                  className="rightarrow"
                  alt="rightnavigation"
                  onClick={() => {
                    setState({
                      goToSlide: state.goToSlide + 1,
                      offsetRadius: 3,
                    });
                    audio.play();
                  }}
                />
              </div>
            </Col>          
          </Row>
        </Container>
      </div>
    </>
  );
}